import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { PermittedItemType } from './common';
import { filterPermittedItems } from './helpers';

type UseFilterPermittedItemsReturnType<U extends string> = {
  filterPermittedItems: <T extends PermittedItemType<U>>(items: T[]) => T[];
};

export const useFilterPermittedItems = <
  U extends string,
>(): UseFilterPermittedItemsReturnType<U> => {
  const { hasOneOfPermissions } = usePermissionContext();

  const filterPermittedItemsWithPermissions = <T extends PermittedItemType<U>>(
    items: T[]
  ): T[] => {
    return filterPermittedItems<U, T>({ items, hasOneOfPermissions });
  };

  return { filterPermittedItems: filterPermittedItemsWithPermissions };
};
